// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  z-index: 9999;
  padding: 20px;
}
.error-page .error-box {
  background: white;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
}
.error-page .error-box .error-icon {
  font-size: 48px;
  margin-bottom: 20px;
}
.error-page .error-box h2 {
  color: #333;
  margin-bottom: 15px;
  font-size: 24px;
  font-weight: 600;
}
.error-page .error-box p {
  color: #666;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 1.5;
}
.error-page .error-box .error-type {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 6px;
  padding: 12px;
  margin: 15px 0;
  color: #856404;
  font-size: 14px;
  text-align: left;
}
.error-page .error-box .error-details {
  margin: 20px 0;
  text-align: left;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 15px;
}
.error-page .error-box .error-details summary {
  cursor: pointer;
  font-weight: 600;
  color: #495057;
  margin-bottom: 10px;
  outline: none;
}
.error-page .error-box .error-details summary:hover {
  color: #007bff;
}
.error-page .error-box .error-details pre {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  color: #dc3545;
  margin: 10px 0;
}
.error-page .error-box .error-details .stack-trace {
  border-top: 1px solid #dee2e6;
  padding-top: 10px;
  font-size: 11px;
  max-height: 200px;
  overflow-y: auto;
  color: #6c757d;
}
.error-page .error-box .error-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 25px;
}
@media (min-width: 480px) {
  .error-page .error-box .error-buttons {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }
}
.error-page .error-box .error-button {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
}
.error-page .error-box .error-button.primary {
  background: #007bff;
  color: white;
}
.error-page .error-box .error-button.primary:hover {
  background: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}
.error-page .error-box .error-button.secondary {
  background: #28a745;
  color: white;
}
.error-page .error-box .error-button.secondary:hover {
  background: #1e7e34;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}
.error-page .error-box .error-button.tertiary {
  background: #6c757d;
  color: white;
}
.error-page .error-box .error-button.tertiary:hover {
  background: #545b62;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}
.error-page .error-box .error-button:active {
  transform: translateY(0);
}
.error-page .error-box .error-button:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ErrorPage/ErrorPage.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,0BAAA;EACA,aAAA;EACA,aAAA;AACF;AACE;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AACJ;AACI;EACE,eAAA;EACA,mBAAA;AACN;AAEI;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAAN;AAGI;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AADN;AAII;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAFN;AAKI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAHN;AAKM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;AAHR;AAKQ;EACE,cAAA;AAHV;AAOM;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;AALR;AAQM;EACE,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AANR;AAUI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AARN;AAUM;EANF;IAOI,mBAAA;IACA,uBAAA;IACA,eAAA;EAPN;AACF;AAUI;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AARN;AAUM;EACE,mBAAA;EACA,YAAA;AARR;AAUQ;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AARV;AAYM;EACE,mBAAA;EACA,YAAA;AAVR;AAYQ;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AAVV;AAcM;EACE,mBAAA;EACA,YAAA;AAZR;AAcQ;EACE,mBAAA;EACA,2BAAA;EACA,+CAAA;AAZV;AAgBM;EACE,wBAAA;AAdR;AAiBM;EACE,0BAAA;EACA,mBAAA;AAfR","sourcesContent":[".error-page {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.8);\r\n  backdrop-filter: blur(5px);\r\n  z-index: 9999;\r\n  padding: 20px;\r\n\r\n  .error-box {\r\n    background: white;\r\n    padding: 40px 30px;\r\n    border-radius: 12px;\r\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\r\n    text-align: center;\r\n    max-width: 600px;\r\n    width: 100%;\r\n    max-height: 80vh;\r\n    overflow-y: auto;\r\n\r\n    .error-icon {\r\n      font-size: 48px;\r\n      margin-bottom: 20px;\r\n    }\r\n\r\n    h2 {\r\n      color: #333;\r\n      margin-bottom: 15px;\r\n      font-size: 24px;\r\n      font-weight: 600;\r\n    }\r\n\r\n    p {\r\n      color: #666;\r\n      margin-bottom: 20px;\r\n      font-size: 16px;\r\n      line-height: 1.5;\r\n    }\r\n\r\n    .error-type {\r\n      background: #fff3cd;\r\n      border: 1px solid #ffeeba;\r\n      border-radius: 6px;\r\n      padding: 12px;\r\n      margin: 15px 0;\r\n      color: #856404;\r\n      font-size: 14px;\r\n      text-align: left;\r\n    }\r\n\r\n    .error-details {\r\n      margin: 20px 0;\r\n      text-align: left;\r\n      background: #f8f9fa;\r\n      border: 1px solid #e9ecef;\r\n      border-radius: 6px;\r\n      padding: 15px;\r\n\r\n      summary {\r\n        cursor: pointer;\r\n        font-weight: 600;\r\n        color: #495057;\r\n        margin-bottom: 10px;\r\n        outline: none;\r\n\r\n        &:hover {\r\n          color: #007bff;\r\n        }\r\n      }\r\n\r\n      pre {\r\n        background: #fff;\r\n        border: 1px solid #dee2e6;\r\n        border-radius: 4px;\r\n        padding: 10px;\r\n        font-size: 12px;\r\n        overflow-x: auto;\r\n        white-space: pre-wrap;\r\n        word-break: break-word;\r\n        color: #dc3545;\r\n        margin: 10px 0;\r\n      }\r\n\r\n      .stack-trace {\r\n        border-top: 1px solid #dee2e6;\r\n        padding-top: 10px;\r\n        font-size: 11px;\r\n        max-height: 200px;\r\n        overflow-y: auto;\r\n        color: #6c757d;\r\n      }\r\n    }\r\n\r\n    .error-buttons {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 12px;\r\n      margin-top: 25px;\r\n\r\n      @media (min-width: 480px) {\r\n        flex-direction: row;\r\n        justify-content: center;\r\n        flex-wrap: wrap;\r\n      }\r\n    }\r\n\r\n    .error-button {\r\n      padding: 12px 24px;\r\n      border: none;\r\n      border-radius: 6px;\r\n      font-size: 16px;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      transition: all 0.3s ease;\r\n      min-width: 140px;\r\n\r\n      &.primary {\r\n        background: #007bff;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background: #0056b3;\r\n          transform: translateY(-2px);\r\n          box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\r\n        }\r\n      }\r\n\r\n      &.secondary {\r\n        background: #28a745;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background: #1e7e34;\r\n          transform: translateY(-2px);\r\n          box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\r\n        }\r\n      }\r\n\r\n      &.tertiary {\r\n        background: #6c757d;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background: #545b62;\r\n          transform: translateY(-2px);\r\n          box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);\r\n        }\r\n      }\r\n\r\n      &:active {\r\n        transform: translateY(0);\r\n      }\r\n\r\n      &:focus {\r\n        outline: 2px solid #007bff;\r\n        outline-offset: 2px;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
